import React, { useState } from 'react';
import {
    ConfigProvider,
    theme,
    Table,
    Avatar,
    Input,
    Button,
    Dropdown,
    Modal,
    DatePicker,
    Select,
    Tabs
} from 'antd';
import {
    Minus,
    Plus,
    MoreVertical,
    Paperclip,
    Send,
    Smile,
    User,
    Briefcase,
    DollarSign,
    Link2,
    History,
    Tag,
    X,
    CheckCircle2
} from 'lucide-react';

import Layout from '../../Layout'
import { Link } from 'react-router-dom';
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { TextArea } = Input;

// 1. TẠO DỮ LIỆU NHÂN VIÊN (MOCK DATA)
const USER_DB = {
    trang: { label: 'Nguyễn Thu Trang', department: '[GTV] Phòng Hành...', position: 'Giám đốc tài chính', role: '[KHOTHI] Giám đốc' },
    anh: { label: 'Mai Tuyết Anh', department: 'Phòng kinh doanh...', position: '[KHOTHI] Chuyên...', role: '[KHOTHI] Chuyên...' },
    huan: { label: 'Mr. Huấn', department: 'Phòng Kỹ thuật', position: 'Kỹ sư phần mềm', role: 'Nhân viên' }
};
// Chuyển object thành mảng options cho Select
const userOptions = Object.keys(USER_DB).map(key => ({ value: key, label: USER_DB[key].label }));

export default function SupplierDetail() {
    const [isDarkMode, setIsDarkMode] = useState(false);

    // ================= STATES =================
    const [isDebtModalOpen, setIsDebtModalOpen] = useState(false);
    const [isAssigneeModalOpen, setIsAssigneeModalOpen] = useState(false);

    const [expandedBlocks, setExpandedBlocks] = useState({
        general: true,
        assignee: true,
        debt: true,
    });

    const toggleBlock = (key) => {
        setExpandedBlocks(prev => ({ ...prev, [key]: !prev[key] }));
    };

    // State Thảo luận
    const [comments, setComments] = useState([
        { id: 1, author: 'Mr. Huấn', text: 'Kiểm tra hợp đồng nháp máy', time: '25 giây trước' }
    ]);
    const [inputValue, setInputValue] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [editValue, setEditValue] = useState('');

    const handleSendComment = () => {
        if (!inputValue.trim()) return;
        const newComment = { id: Date.now(), author: 'Người dùng', text: inputValue, time: 'Vừa xong' };
        setComments([...comments, newComment]);
        setInputValue('');
    };

    const handleDeleteComment = (id) => {
        setComments(comments.filter(c => c.id !== id));
    };

    const startEdit = (id, text) => {
        setEditingId(id);
        setEditValue(text);
    };

    const saveEdit = (id) => {
        setComments(comments.map(c => c.id === id ? { ...c, text: editValue } : c));
        setEditingId(null);
    };

    // State cho Modal "Cập nhật người phụ trách" (Đã update lấy từ USER_DB)
    const [modalAssignees, setModalAssignees] = useState([
        { id: 1, user: 'trang', department: USER_DB['trang'].department, position: USER_DB['trang'].position, role: USER_DB['trang'].role },
        { id: 2, user: 'anh', department: USER_DB['anh'].department, position: USER_DB['anh'].position, role: USER_DB['anh'].role },
    ]);

    const handleAddModalAssignee = () => {
        setModalAssignees([
            ...modalAssignees,
            { id: Date.now(), user: null, department: '', position: '', role: '' }
        ]);
    };

    const handleRemoveModalAssignee = (id) => {
        setModalAssignees(modalAssignees.filter(item => item.id !== id));
    };

    // 2. HÀM XỬ LÝ KHI THAY ĐỔI NGƯỜI PHỤ TRÁCH (TỰ ĐỘNG ĐIỀN)
    const handleChangeModalUser = (id, selectedUserValue) => {
        const userInfo = USER_DB[selectedUserValue]; // Lấy thông tin user từ DB
        setModalAssignees(modalAssignees.map(item =>
            item.id === id
                ? {
                    ...item,
                    user: selectedUserValue,
                    department: userInfo?.department || '',
                    position: userInfo?.position || '',
                    role: userInfo?.role || ''
                }
                : item
        ));
    };

    // ================= MOCK DATA BẢNG =================
    const assigneeColumns = [
        { title: 'Từ ngày', dataIndex: 'fromDate', key: 'fromDate' },
        { title: 'Đến ngày', dataIndex: 'toDate', key: 'toDate' },
        { title: 'Họ và tên', dataIndex: 'name', key: 'name' },
        { title: 'Phòng ban', dataIndex: 'department', key: 'department' },
        { title: 'Vị trí', dataIndex: 'position', key: 'position' },
        { title: 'Chức vụ', dataIndex: 'role', key: 'role' },
    ];
    const assigneeData = [
        { key: '1', fromDate: '02/12/2024', toDate: '', name: 'Nguyễn Thu Trang', department: 'Phòng Hành Chính Nhân Sự', position: 'Giám đốc tài chính', role: 'Giám Đốc' },
        { key: '2', fromDate: '27/04/2025', toDate: '', name: 'Mai Tuyết Anh', department: 'Phòng kinh doanh 2 - HN', position: 'Chuyên viên Kinh doanh', role: 'Chuyên viên' },
    ];

    const debtColumns = [
        { title: 'Mã chứng từ', dataIndex: 'code', key: 'code', className: 'font-medium cursor-pointer text-[#3e91ab]' },
        { title: 'Ngày hạch toán', dataIndex: 'date', key: 'date' },
        { title: 'Nguồn chứng từ', dataIndex: 'source', key: 'source' },
        { title: 'Dư nợ', dataIndex: 'debit', key: 'debit', align: 'right' },
        { title: 'Dư có', dataIndex: 'credit', key: 'credit', align: 'right' },
        { title: 'Còn lại', dataIndex: 'balance', key: 'balance', align: 'right' },
    ];
    const debtData = [
        { key: '1', code: 'DHM_2025_0156', date: '23/03/2025', source: 'Đơn hàng mua', debit: '450.000 ₫', credit: '', balance: '450.000 ₫' },
        { key: '2', code: 'CN015', date: '10/04/2025', source: 'Khác', debit: '4.500.000 ₫', credit: '', balance: '4.950.000 ₫' },
        { key: '3', code: 'CN035', date: '22/08/2026', source: 'Khác', debit: '1.000.000 ₫', credit: '', balance: '5.950.000 ₫' },
    ];

    // ================= THEME & UI COMPONENTS =================
    const antdThemeConfig = {
        token: {
            colorPrimary: '#3e91ab',
            colorBgContainer: isDarkMode ? '#1f2937' : '#ffffff',
            colorText: isDarkMode ? '#f3f4f6' : '#374151',
            colorBorder: isDarkMode ? '#4b5563' : '#d1d5db',
            borderRadius: 6,
        },
        components: { Table: { headerBg: isDarkMode ? '#374151' : '#f9fafb' } },
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    };

    const CardHeader = ({ title, blockKey }) => (
        <div className="flex justify-between items-center mb-4 pb-2 border-b dark:border-gray-700">
            <h3 className="font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
            <div onClick={() => toggleBlock(blockKey)} className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
                {expandedBlocks[blockKey] ? <Minus size={16} /> : <Plus size={16} />}
            </div>
        </div>
    );

    return (
        <Layout>
            <div>

                {/* --- HEADER ACTIONS --- */}
                <div className="border-b dark:border-gray-700 p-3 flex flex-wrap justify-between items-center gap-4 sticky top-[64px] bg-white dark:bg-[#1f1f1f] z-10">
                    <div className="flex sm:items-center gap-4 text-sm sm:flex-row flex-col items-start">
                        <div className="flex sm:items-center gap-4 text-sm items-start">
                            <Link to="/supplier" className="flex items-center gap-2">
                                <LeftOutlined className="w-6 h-6 flex items-center justify-center rounded-full bg-[#3e91ab] hover:bg-[#357f96] text-white" />
                            </Link>
                            <span className="font-medium text-[#3e91ab] border-b-2 border-[#3e91ab] pb-1 cursor-pointer">Chi tiết ncc</span>
                        </div>
                        <span className="text-gray-500 dark:text-gray-400 pb-1">KHOTHI.1224.03 - Công Ty TNHH Tư Vấn Thương Mại Dịch Vụ Nag</span>
                    </div>

                    <div className='overflow-x-auto no-scrollbar'>
                        <div className="flex items-center gap-4 xl:gap-5 w-full xl:w-auto ml-auto min-w-max text-000000e0 text-xs md:text-sm">
                            <button className="flex items-center gap-1.5 hover:text-[#3e91ab]" onClick={() => setIsAssigneeModalOpen(true)}><User size={14} /> Phụ trách</button>
                            <button className="flex items-center gap-1.5 hover:text-[#3e91ab]"><Briefcase size={14} /> Kinh doanh</button>
                            <button onClick={() => setIsDebtModalOpen(true)} className="flex items-center gap-1.5 hover:text-[#3e91ab]"><DollarSign size={14} /> Công nợ</button>
                            <button className="flex items-center gap-1.5 hover:text-[#3e91ab]"><Plus size={14} /> Tạo mới</button>
                            <button className="flex items-center gap-1.5 hover:text-[#3e91ab]"><Link2 size={14} /> Liên kết</button>
                        </div>
                    </div>
                </div>

                {/* --- MAIN LAYOUT --- */}
                <div className="mx-auto mt-4 grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-4">

                    {/* CỘT TRÁI */}
                    <div className="flex flex-col gap-4 overflow-hidden">

                        {/* 1. THÔNG TIN CHUNG */}
                        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700 transition-all">
                            <CardHeader title="Thông tin chung" blockKey="general" />
                            {expandedBlocks.general && (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-8 text-sm animate-in fade-in duration-300 mt-2">
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Mã nhà cung cấp</p>
                                        <p className="font-medium text-gray-900 dark:text-gray-200">KHOTHI.1224.03</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Loại nhà cung cấp</p>
                                        <p className="font-medium text-gray-900 dark:text-gray-200">Tổ chức</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Tên nhà cung cấp</p>
                                        <p className="font-medium text-gray-900 dark:text-gray-200">Công Ty TNHH Tư Vấn Thương Mại Dịch Vụ Nag</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Mã số thuế/ĐKKD</p>
                                        <p className="font-medium text-gray-900 dark:text-gray-200">0871335477</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Ngày thành lập</p>
                                        <p className="font-medium text-gray-900 dark:text-gray-200">17/02/1984</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Lĩnh vực</p>
                                        <p className="font-medium text-gray-900 dark:text-gray-200">Điện tử - Điện lạnh</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Phụ trách</p>
                                        <div className="flex items-center gap-3">
                                            <div className="flex items-center gap-1.5 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded-full w-max">
                                                <Avatar size={20} src="https://i.pravatar.cc/150?u=a1" />
                                                <span className="text-xs font-medium dark:text-gray-200">Mai Tuyết Anh</span>
                                            </div>
                                            <div className="flex items-center gap-1.5 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded-full w-max">
                                                <Avatar size={20} src="https://i.pravatar.cc/150?u=a2" />
                                                <span className="text-xs font-medium dark:text-gray-200">Nguyễn Thu Trang</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Khách hàng</p>
                                        <p className="text-gray-400">--</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Điện thoại</p>
                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#3e91ab]/10 text-[#3e91ab]">
                                            0974955563
                                        </span>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Email</p>
                                        <p className="font-medium text-[#3e91ab] cursor-pointer">nguyenvancga@gmail.com</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Mô tả</p>
                                        <p className="text-gray-400">--</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Tài khoản</p>
                                        <p className="text-gray-400">--</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* 2. LỊCH SỬ PHỤ TRÁCH */}
                        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700 transition-all">
                            <div className="flex justify-between items-center mb-4 pb-2 border-b dark:border-gray-700">
                                <h3 className="font-semibold text-gray-800 dark:text-gray-100">Lịch sử phụ trách</h3>
                                <div className="flex gap-4 items-center">
                                    <div onClick={() => toggleBlock('assignee')} className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
                                        {expandedBlocks.assignee ? <Minus size={16} /> : <Plus size={16} />}
                                    </div>
                                </div>
                            </div>
                            {expandedBlocks.assignee && (
                                <div className="overflow-x-auto animate-in fade-in duration-300">
                                    <Table columns={assigneeColumns} dataSource={assigneeData} rowSelection={{ type: 'checkbox' }} pagination={false} size="small"
                                        className="custom-ant-table"
                                        scroll={{ x: "max-content" }}
                                    />
                                </div>
                            )}
                        </div>

                        {/* 3. CÔNG NỢ */}
                        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700 transition-all">
                            <CardHeader title="Công nợ" blockKey="debt" />
                            {expandedBlocks.debt && (
                                <div className="overflow-x-auto animate-in fade-in duration-300">
                                    <Table
                                        columns={debtColumns}
                                        dataSource={debtData}
                                        rowSelection={{ type: 'checkbox' }}
                                        pagination={false}
                                        size="small"
                                        className="custom-ant-table"
                                        scroll={{ x: "max-content" }}
                                        summary={() => (
                                            <Table.Summary.Row className="bg-gray-50 dark:bg-gray-700/50 font-semibold text-gray-900 dark:text-gray-100">
                                                <Table.Summary.Cell index={0} colSpan={4} align="center">Tổng</Table.Summary.Cell>
                                                <Table.Summary.Cell index={1} align="right">5.950.000 ₫</Table.Summary.Cell>
                                                <Table.Summary.Cell index={2} align="right">0 ₫</Table.Summary.Cell>
                                                <Table.Summary.Cell index={3} align="right">5.950.000 ₫</Table.Summary.Cell>
                                            </Table.Summary.Row>
                                        )}
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* CỘT PHẢI */}
                    <div className="flex flex-col gap-4 h-full">
                        {/* Tabs Thảo luận / Lịch sử */}
                        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border dark:border-gray-700 flex flex-col flex-1 min-h-[600px]">

                            <Tabs
                                defaultActiveKey="1"
                                className="px-4 pt-2 flex-1 flex flex-col"
                                items={[
                                    {
                                        key: '1',
                                        label: 'Thảo luận',
                                        children: (
                                            <div className="flex flex-col h-full mt-2">
                                                <div className="flex-1 overflow-y-auto mb-4 pr-2 max-h-[450px]">
                                                    {comments.map(comment => (
                                                        <div key={comment.id} className="flex gap-3 mb-6">
                                                            <Avatar style={{ backgroundColor: '#84cc16' }}>{comment.author.charAt(0)}</Avatar>
                                                            <div className="flex-1">
                                                                <div className="flex justify-between items-start">
                                                                    <div className="w-full">
                                                                        <span className="font-semibold text-gray-800 dark:text-gray-200 text-sm">{comment.author}</span>
                                                                        {editingId === comment.id ? (
                                                                            <div className="mt-1 flex gap-2 w-full max-w-sm">
                                                                                <Input value={editValue} onChange={(e) => setEditValue(e.target.value)} onPressEnter={() => saveEdit(comment.id)} size="small" autoFocus />
                                                                                <Button size="small" type="primary" onClick={() => saveEdit(comment.id)} className="bg-[#3e91ab]">Lưu</Button>
                                                                                <Button size="small" onClick={() => setEditingId(null)}>Hủy</Button>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="bg-gray-100 dark:bg-gray-700/50 p-3 rounded-lg rounded-tl-none mt-1 text-sm text-gray-800 dark:text-gray-200 border dark:border-gray-700 w-fit">
                                                                                {comment.text}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    <Dropdown
                                                                        menu={{
                                                                            items: [
                                                                                { key: 'edit', label: 'Sửa bình luận', onClick: () => startEdit(comment.id, comment.text) },
                                                                                { key: 'delete', label: 'Xóa bình luận', danger: true, onClick: () => handleDeleteComment(comment.id) },
                                                                            ],
                                                                        }}
                                                                        trigger={['click']} placement="bottomRight"
                                                                    >
                                                                        <MoreVertical size={16} className="text-gray-400 cursor-pointer hover:text-gray-600 dark:hover:text-gray-300 ml-2 mt-1" />
                                                                    </Dropdown>
                                                                </div>

                                                                <div className="flex items-center gap-4 mt-2 text-xs text-gray-500 dark:text-gray-400">
                                                                    <span>{comment.time}</span>
                                                                    <span className="cursor-pointer hover:text-[#3e91ab]">Thích</span>
                                                                    <span className="cursor-pointer hover:text-[#3e91ab]">Trả lời</span>
                                                                    <CheckCircle2 size={14} className="text-green-500 ml-auto" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                                <div className="border dark:border-gray-600 rounded-lg p-3 bg-gray-50 dark:bg-gray-700/30 shrink-0">
                                                    <Input
                                                        bordered={false}
                                                        placeholder="Viết thảo luận..."
                                                        className="mb-2 dark:text-gray-200"
                                                        value={inputValue}
                                                        onChange={(e) => setInputValue(e.target.value)}
                                                        onPressEnter={handleSendComment}
                                                    />
                                                    <div className="flex justify-between items-center text-gray-400">
                                                        <div className="flex gap-3">
                                                            <Paperclip size={16} className="cursor-pointer hover:text-[#3e91ab]" />
                                                            <Smile size={16} className="cursor-pointer hover:text-[#3e91ab]" />
                                                        </div>
                                                        <Send size={16} className="cursor-pointer text-[#3e91ab]" onClick={handleSendComment} />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    },
                                    {
                                        key: '2',
                                        label: 'Lịch sử hoạt động',
                                        children: (
                                            <div className="mt-4">
                                                <div className="relative pl-6 border-l border-gray-200 dark:border-gray-600 ml-4 pb-6">
                                                    <div className="absolute -left-[16px] top-0 bg-white dark:bg-gray-800 rounded-full p-0.5">
                                                        <Avatar style={{ backgroundColor: '#5c8e9b' }} size={28} icon={<History size={14} />} />
                                                    </div>
                                                    <div className="pt-0.5">
                                                        <div className="text-sm dark:text-gray-300">
                                                            <span className="font-semibold text-gray-800 dark:text-gray-200">Mr. Huấn</span> đã ghi nhận dư nợ
                                                        </div>
                                                        <div className="text-xs text-gray-400 mb-2 mt-0.5">10:25 ngày 22/08/2026</div>
                                                        <div className="bg-[#f8fafc] dark:bg-gray-700/30 p-3 rounded-md text-sm text-gray-600 dark:text-gray-300 border border-[#3e91ab]/40">
                                                            <p>Đã ghi nhận công nợ:</p>
                                                            <p>Mã CN: <b className="text-gray-800 dark:text-gray-200 font-medium">CN035</b></p>
                                                            <p>Số tiền: <b className="text-red-500 font-medium">1.000.000</b></p>
                                                            <p>Lý do: lần sau thanh toán</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </div>

                {/* ================= MODALS ================= */}

                {/* MODAL: Thêm Công Nợ */}
                <Modal
                    title={<span className="dark:text-white">Công nợ</span>}
                    open={isDebtModalOpen}
                    onCancel={() => setIsDebtModalOpen(false)}
                    footer={[
                        <Button key="back" onClick={() => setIsDebtModalOpen(false)}>HỦY BỎ</Button>,
                        <Button key="submit" type="primary" style={{ backgroundColor: '#3e91ab' }}>CẬP NHẬT</Button>,
                    ]}
                    className="dark-modal"
                >
                    <div className="grid grid-cols-3 gap-4 mt-4">
                        <div>
                            <label className="text-xs text-gray-500 dark:text-gray-400">Mã CN *</label>
                            <Input defaultValue="CN038" className="mt-1" />
                        </div>
                        <div>
                            <label className="text-xs text-gray-500 dark:text-gray-400">Ngày *</label>
                            <DatePicker className="w-full mt-1" format="DD/MM/YYYY" />
                        </div>
                        <div>
                            <label className="text-xs text-gray-500 dark:text-gray-400">Số tiền *</label>
                            <Input className="mt-1" />
                        </div>
                        <div className="col-span-3 mt-2">
                            <label className="text-xs text-gray-500 dark:text-gray-400">Lý do *</label>
                            <TextArea rows={3} className="mt-1" />
                        </div>
                    </div>
                </Modal>

                {/* MODAL: Cập nhật người phụ trách */}
                <Modal
                    title={<span className="dark:text-white">Cập nhật người phụ trách</span>}
                    open={isAssigneeModalOpen}
                    onCancel={() => setIsAssigneeModalOpen(false)}
                    width={900}
                    footer={[
                        <Button key="back" onClick={() => setIsAssigneeModalOpen(false)}>HỦY BỎ</Button>,
                        <Button key="submit" type="primary" style={{ backgroundColor: '#3e91ab' }}>CẬP NHẬT</Button>,
                    ]}
                >
                    <div className="mt-4 mb-2 grid grid-cols-[1fr_1fr_1.5fr_1.5fr_1fr_1fr_auto] gap-2 text-xs font-medium text-gray-500 dark:text-gray-400 px-1">
                        <span>Từ ngày *</span>
                        <span>Đến ngày</span>
                        <span>Người phụ trách</span>
                        <span>Phòng ban</span>
                        <span>Vị trí</span>
                        <span>Chức vụ</span>
                        <span className="w-4"></span>
                    </div>

                    {/* MAP DỮ LIỆU ĐỘNG */}
                    {modalAssignees.map(item => (
                        <div key={item.id} className="grid grid-cols-[1fr_1fr_1.5fr_1.5fr_1fr_1fr_auto] gap-2 mb-3 items-center">
                            <DatePicker format="DD/MM/YYYY" placeholder="Select date" />
                            <DatePicker format="DD/MM/YYYY" placeholder="Select date" />
                            <Select
                                value={item.user}
                                onChange={(val) => handleChangeModalUser(item.id, val)}
                                placeholder="Chọn người..."
                                options={userOptions}
                            />
                            {/* 3 CỘT NÀY ĐÃ ĐƯỢC CHUYỂN THÀNH CHỈ ĐỌC (READ-ONLY) */}
                            <Input
                                value={item.department}
                                readOnly
                                className="bg-gray-50 dark:bg-gray-700/50 text-gray-500 dark:text-gray-400 pointer-events-none"
                            />
                            <Input
                                value={item.position}
                                readOnly
                                className="bg-gray-50 dark:bg-gray-700/50 text-gray-500 dark:text-gray-400 pointer-events-none"
                            />
                            <Input
                                value={item.role}
                                readOnly
                                className="bg-gray-50 dark:bg-gray-700/50 text-gray-500 dark:text-gray-400 pointer-events-none"
                            />

                            {/* Nút Xóa dòng */}
                            <X
                                size={16}
                                className="text-gray-400 hover:text-red-500 cursor-pointer"
                                onClick={() => handleRemoveModalAssignee(item.id)}
                            />
                        </div>
                    ))}

                    {/* Nút Cộng dòng */}
                    <button
                        onClick={handleAddModalAssignee}
                        className="flex items-center justify-center w-6 h-6 rounded-full border border-[#3e91ab] text-[#3e91ab] hover:bg-[#3e91ab] hover:text-white transition-colors mt-2"
                    >
                        <Plus size={14} />
                    </button>
                </Modal>

            </div>
        </Layout>
    );
}